import React from "react";

const FormSubmitButton = ({ form }) => {
  return (
    <div className="sm:col-span-2 justify-self-end">
      <input type="hidden" name="bot-field" />
      <input type="hidden" name="form-name" value={form} />
      <button
        type="submit"
        className="group bg-teal hover:bg-darkteal inline-block text-white font-bold text-sm leading-4 rounded-md py-4 px-6 cursor-pointer duration-300"
      >
        Submit
      </button>
    </div>
  );
};

export default FormSubmitButton;
